module.exports = "./img/b1ac8cae31043c5f0c502f9f81020706.jpg";